import { Link } from "@tanstack/react-router";
import { useT } from "@/lib/i18n";
import { CATEGORIES } from "@/lib/calculators";

export function Footer() {
  const { t, lang } = useT();
  return (
    <footer className="mt-16 border-t border-border bg-sidebar">
      <div className="mx-auto grid max-w-7xl gap-8 px-3 py-8 sm:px-4 sm:py-10 md:grid-cols-4 md:px-6">
        <div>
          <h2 className="mb-3 text-sm font-bold">{t("brand.appName")}</h2>
          <p className={`text-xs text-muted-foreground ${lang === "bn" ? "font-bn" : ""}`}>{t("brand.tagline")}</p>
        </div>
        <div className="md:col-span-2">
          <h2 className="mb-3 text-sm font-bold">{t("common.categories")}</h2>
          <ul className="grid grid-cols-2 gap-2 text-sm">
            {CATEGORIES.map((c) => (
              <li key={c.id} className={lang === "bn" ? "font-bn" : ""}>
                <span className="mr-1">{c.emoji}</span>
                {t(`categories.${c.id}`)}
              </li>
            ))}
          </ul>
        </div>
        <div>
          <h2 className="mb-3 text-sm font-bold">Links</h2>
          <ul className="space-y-2 text-sm">
            <li><Link to="/about" className="hover:text-accent">{t("footer.about")}</Link></li>
            <li><Link to="/why" className="hover:text-accent">{lang === "bn" ? "কেন বাংলা ক্যালকুলেটর" : "Why Bangla Calculator"}</Link></li>
            <li><Link to="/privacy" className="hover:text-accent">{t("footer.privacy")}</Link></li>
            <li><Link to="/terms" className="hover:text-accent">{t("footer.terms")}</Link></li>
            <li><Link to="/contact" className="hover:text-accent">{t("footer.contact")}</Link></li>
          </ul>
        </div>
      </div>
      <div className="border-t border-border py-4 text-center text-xs text-muted-foreground">
        <span className={lang === "bn" ? "font-bn" : ""}>{t("footer.copyright")}</span>
      </div>
    </footer>
  );
}
